import React from 'react'
import * as InterialStyle from "../../styles/dabin/StyledComponenetInterialRenewal";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

import manual_01 from "../../images/interiorRenewalSplash/manual-01.jpg"
import manual_02 from "../../images/interiorRenewalSplash/manual-02.jpg"
import manual_03 from "../../images/interiorRenewalSplash/manual-03.jpg"
import manual_04 from "../../images/interiorRenewalSplash/manual-04.jpg"
import manual_05 from "../../images/interiorRenewalSplash/manual-05.jpg"

import { IoIosCheckmarkCircleOutline } from "react-icons/io";

const InteriorRenewalFunction = () => {
  const images = [manual_01, manual_02, manual_03, manual_04, manual_05];
  return (
    <div>
      <InterialStyle.InteriorRenewalFunctionContainer>
        <div className="function-text-box">
          <h3>기술이 만든 스마트 영업의 시대</h3>
          <h2>견적부터 계약까지 단 <span>5분</span>이면 충분 합니다</h2>
        </div>
        <div className="function-effect-box">
          <Swiper
            navigation={{
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            }}
            modules={[Navigation]}
          >
            {images.map((tmp, idx)=>{
              return (
                <SwiperSlide
                key={idx}
                >
                  <img src={tmp} alt="slide-img" />
                </SwiperSlide>
              )
            })}
          </Swiper>
            <div className="swiper-button-prev"></div>
            <div className="swiper-button-next"></div>
        </div>
        <div className="mobile-function-text-box">
            <p><IoIosCheckmarkCircleOutline/> 실시간 견적 자동 생성 및 관리</p>
            <p><IoIosCheckmarkCircleOutline/> 브랜드별 실시간 재고 조회</p>
            <p><IoIosCheckmarkCircleOutline/> 고객별 거래 데이터 관리</p>
        </div>
        <div className='function-end-text'>
          지금 바로, AOS를 경험해보세요
        </div>
      </InterialStyle.InteriorRenewalFunctionContainer>
    </div>
  )
}

export default InteriorRenewalFunction